// extracted by mini-css-extract-plugin
export default {"message":"MessageBubble_message__Cb26+","user":"MessageBubble_user__TR7Hf","seller":"MessageBubble_seller__7YSe-","timeStamp":"MessageBubble_timeStamp__r6SU8"};